import { AppStore, Spinner } from '@shared/icons';
import { APPLE_PAY_ICON_CLASS_NAME } from '../../../../../applePayButtonClassName';

type CheckoutPayButtonContentProps = {
  isSubmitting: boolean;
  isApplePay: boolean;
  ctaLabel: string;
  applePayPayWithLabel: string;
  applePayPayLabel: string;
};

function CheckoutPayButtonContent({ isSubmitting, isApplePay, ctaLabel, applePayPayWithLabel, applePayPayLabel }: CheckoutPayButtonContentProps) {
  if (isSubmitting) {
    return <Spinner size="small" className="animate-spin w-5" aria-label="Processing" />;
  }

  if (isApplePay) {
    return (
      <>
        <span>{applePayPayWithLabel}</span>
        <AppStore size="small" className={APPLE_PAY_ICON_CLASS_NAME} />
        <span>{applePayPayLabel}</span>
      </>
    );
  }

  return ctaLabel;
}

export { CheckoutPayButtonContent, type CheckoutPayButtonContentProps };
